module.exports = __webpack_public_path__ + "static/media/prep_departed.e86f4d9b.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pdfs/hymns/prep_departed.pdf
// module id = 788
// module chunks = 2